import React, { useMemo } from 'react'
import { TableListLoader } from 'src/components/Reusable/ContentLoaders/TableListLoader'
import { EmptyGrid } from 'src/components/Reusable/Grid'
import { EvidenceGroup } from '@trustero/trustero-api-web/lib/attachment/attachment_pb'
import { TabType } from 'src/components/Reusable/Tabs'
import { useEvidenceToControlMappingInfo } from '../../evidence.hooks'
import { EVIDENCE_TABS } from './EvidenceTabs.constants'
import { EvidenceControlMappingsBody } from './controlmappings/EvidenceControlMappingsBody'

export const useEvidenceControlMappingsTabs = ({
  evidence,
}: {
  evidence?: EvidenceGroup
}): TabType | null => {
  const evidenceId = evidence?.getEvidenceId() || ''
  const { data, isLoading } = useEvidenceToControlMappingInfo([evidenceId])
  const mapping = useMemo(() => {
    const mappings = data ? data.getEvidenceControlMappingsList() : []
    if (mappings && mappings.length > 0) {
      return mappings[0]
    }
  }, [data])
  if (!evidence) {
    return null
  }
  const tabTitle = EVIDENCE_TABS.SUGGESTED_CONTROLS
  if (isLoading) {
    return {
      title: tabTitle,
      count: 0,
      body: <TableListLoader />,
    } as TabType
  }
  if (!mapping) {
    return {
      title: tabTitle,
      count: 0,
      body: (
        <EmptyGrid message="There are no suggested controls for this evidence." />
      ),
    } as TabType
  }
  return {
    title: tabTitle,
    count: mapping?.getSuggestedControlsList().length || 0,
    body: <EvidenceControlMappingsBody mapping={mapping} />,
  } as TabType
}
